/**
 * Flips one class on the product-information section wrapper once it
 * scrolls into view, which blocks/pdp-media-treatment.liquid's scoped
 * <style> tag uses to trigger the product image's fade/scale-in. Same
 * one-shot IntersectionObserver pattern as assets/instagram-feed-grid.js.
 */
class PdpMediaTreatment extends HTMLElement {
  connectedCallback() {
    if (this.dataset.animate !== 'true') return;

    const section = document.getElementById(`shopify-section-${this.dataset.sectionId}`);
    if (!section) return;

    if (
      window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
      !('IntersectionObserver' in window)
    ) {
      section.classList.add('pdp-media-treatment--visible');
      return;
    }

    const observer = new IntersectionObserver(
      (entries, obs) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            section.classList.add('pdp-media-treatment--visible');
            obs.disconnect();
          }
        }
      },
      { threshold: 0.2 }
    );

    observer.observe(section);
  }
}

if (!customElements.get('pdp-media-treatment')) {
  customElements.define('pdp-media-treatment', PdpMediaTreatment);
}
